(function() {
  const url = new URL(window.location);

  // Paths where the redirection should be applied
  const includePaths = [
    // #2968 - remove inclusive of filter.v.availability=1 on redirection of url
    //"/collections", // General collection path
    // Add other collection paths as needed
    // #3300 - apply in-stock filter availability on OUTLET page specific
    "/collections/klem-stock",
    "/collections/elmina-stocks",
    "/collections/mayang-stock",
    "/collections/ioi-stocks",
    "/collections/spm-stocks",
    "/collections/pcm-stocks",
    "/collections/scm-stock",
    "/collections/aeon-stock",
    "/collections/sogo-stocks"
  ];
  
  // List of paths where the redirection should be NOT BE applied
  const restrictedPaths = [
    "#",
    "/pages/loyalty-page",
    "/products"
  ];
  
  // Function to check if the current path is in the included paths
  const isIncludedPath = (path) => {
    return includePaths.some(includePath => path.startsWith(includePath));
  };
  
  // Function to check if the current path is in the restricted paths
  const isRestrictedPath = (path) => {
    return restrictedPaths.some(restrictedPath => path.startsWith(restrictedPath));
  };

  // Debug logs
  // console.log("Current path:", url.pathname);
  // console.log("Is included path:", isIncludedPath(url.pathname));
  // console.log("Is excluded path:", isRestrictedPath(url.pathname));
  
  // Apply redirection only if the path is included and not excluded
  if (isIncludedPath(url.pathname) && !isRestrictedPath(url.pathname) && !url.searchParams.has("filter.v.availability")) {
    url.searchParams.set("filter.v.availability", "1");
    window.location.replace(url.toString());
  }
})();